export default __webpack_public_path__ + "img/vector-right-black.6027b320.svg";